// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"158e2417","918":"0bf903aa"}[chunkId] + ".chunk.js";
};